'use strict';
(function () {
  var link = {
    macos: '#platforms-tabs',
    ios: 'https://apps.apple.com/us/app/id1489167618',
    windows: 'https://assguard.app/windows/download?system=x64',
    android: 'https://play.google.com/store/apps/details?id=com.macpaw.vpn.android',
    linux: '#platforms-tabs',
  }
  function getOS () {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.includes(platform)) {
      os = 'macos';
    } else if (iosPlatforms.includes(platform)) {
      os = 'ios';
    } else if (windowsPlatforms.includes(platform)) {
      os = 'windows';
    } else if (/Android/.test(userAgent)) {
      os = 'android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'linux';
    }

    return os;
  }

  document.querySelectorAll('.universal-download').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();

      var platform = getOS();

      console.log(platform);

      if (platform === 'macos') {
        document.querySelector('[aria-controls=' + platform + ']').click();
      }

      location = link[platform];
    })
  })
})();

'use strict';
(function () {

  function resizeMasonryItem(item) {

    var grid = document.getElementsByClassName('updates__list')[0];
    var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'), 10);
    var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'), 10);
    var rowSpan = Math.ceil((item.querySelector('.updates__link').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

    /* Set the spanning as calculated above (S)*/
    item.style.gridRowEnd = 'span ' + rowSpan;
  }

  function resizeAllMasonryItems() {

    var allItems = document.getElementsByClassName('updates__item--masonry');

    for (var i = 0; i < allItems.length; i++) {
      resizeMasonryItem(allItems[i]);
    }
  }

  var masonryEvents = ['load', 'resize'];

  masonryEvents.forEach(function (event) {
    window.addEventListener(event, resizeAllMasonryItems);
  });
})();

'use strict';
(function () {
  var profileElement = document.querySelector('.profile__content');
  var profileArrowElement = document.querySelector('.profile__arrow');
  var profileMenuElement = document.querySelector('.profile__menu');
  var VISIBLE_MENU_CLASS = 'profile__menu--active';
  var ACTIVE_ARROW_CLASS = 'profile__arrow--active';
  var ESC_CODE = 27;

  var toggleProfileMenu = function () {
    profileArrowElement.classList.toggle(ACTIVE_ARROW_CLASS);
    profileMenuElement.classList.toggle(VISIBLE_MENU_CLASS);
  };

  var onEscPressClose = function (evt) {
    if (evt.keyCode === ESC_CODE) {
      toggleProfileMenu();
      removeListeners();
    }
  };

  var addListeners = function () {
    document.addEventListener('keydown', onEscPressClose);
  };

  var removeListeners = function () {
    document.removeEventListener('keydown', onEscPressClose);
  };

  var onProfileClickShow = function (evt) {
    evt.preventDefault();
    toggleProfileMenu();
    addListeners();
  };

  if (profileElement) {
    profileElement.addEventListener('click', onProfileClickShow);
  }
})();

'use strict';
(function () {
  var header = document.querySelector('.header');
  var menu = header.querySelector('.header__nav-wrapper');
  var button = header.querySelector('.header__burger');
  var body = document.querySelector('body');
  var ESCAPE = 27;

  var addListeners = function () {
    document.addEventListener('keydown', onEscPressClose);
    document.addEventListener('click', onClickClose);
  };

  var removeListeners = function () {
    document.removeEventListener('keydown', onEscPressClose);
    document.removeEventListener('click', onClickClose);
  };

  var toggleMenu = function () {
    menu.classList.toggle('header__nav-wrapper--no-js');
    button.classList.toggle('header__burger--close');
    body.classList.toggle('lock');
  };

  var onClickShow = function () {
    toggleMenu();
    addListeners();
  };

  var onClickClose = function (evt) {
    if (evt.target === menu || evt.target === body) {
      toggleMenu();
      removeListeners();
      button.addEventListener('click', onClickShow);
    }
  };

  var onEscPressClose = function (evt) {
    if (evt.keyCode === ESCAPE) {
      toggleMenu();
      removeListeners();
      button.addEventListener('click', onClickShow);
    }
  };

  var toggleJs = function () {
    // header.classList.remove('header--no-js');
    // menu.classList.remove('header__nav-wrapper--no-js');
    button.addEventListener('click', onClickShow);
  };

  toggleJs();
})();

(function () {
  var header = document.querySelector('.header__wrapper');
  var site = document.querySelector('html');

  var addClass = function () {
    if (site.scrollTop > header.clientHeight) {
      header.classList.add('header__wrapper--sticky');
    } else {
      header.classList.remove('header__wrapper--sticky');
    }
  };
  // document.addEventListener('scroll', addClass);
})();

'use strict';
(function () {
  var indicator = document.querySelector('.scroll-indicator');
  var blogArticle = document.querySelector('.blog-article');


  if (indicator) {
    var scroll = function () {
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      var height = blogArticle.clientHeight;
      var scrolled = (winScroll / height) * 100;
      indicator.style.width = scrolled + '%';
    };

    document.addEventListener('scroll', scroll);
  }
})();

(function () {
  function getOS () {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.includes(platform)) {
      os = 'windows'; // macos
    } else if (iosPlatforms.includes(platform)) {
      os = 'ios';
    } else if (windowsPlatforms.includes(platform)) {
      os = 'windows';
    } else if (/Android/.test(userAgent)) {
      os = 'android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'linux';
    }

    return os;
  }

  document.addEventListener("DOMContentLoaded", function(event) {
    var platform = getOS();

    document.querySelectorAll('.shortcut__list--actions li').forEach(function (li) {
      if (li.dataset.platform.toLowerCase() !== platform) {
        li.remove();
      } else {
        li.style.display = 'block';
      }
    });
  });
})();

'use strict';
(function () {
  var tags = ['all topics', 'vpn', 'torrenting', 'gaming', 'streaming', 'ios',
    'macos', 'windows', 'android', 'google', 'yandex', 'rambler', 'chrome',
    'internet', 'putin'
  ];

  var toggle = document.querySelector('.tags__button');

  if (toggle) {
    var list = document.querySelector('.tags__nav');
    var START = 9;

    var createLink = function (title) {
      var link = document.createElement('a');
      link.classList.add('tags__link');
      link.href = '#';
      link.setAttribute('aria-label', 'Filter by tag name');
      link.innerHTML = title;
      return link;
    };

    var createItem = function (title) {
      var item = document.createElement('li');
      item.classList.add('tags__item');
      item.appendChild(createLink(title));
      return item;
    };

    var addTag = function (title) {
      list.appendChild(createItem(title));
    };

    var onClickShowAllTags = function () {
      toggle.innerHTML = 'Hide all';
      list.innerHTML = '';
      tags.forEach(function (tag) {
        addTag(tag);
      });
      toggle.removeEventListener('click', onClickShowAllTags);
      toggle.addEventListener('click', onClickShowLoadedTags);
    };

    var onClickShowLoadedTags = function () {
      toggle.innerHTML = 'See all';
      list.innerHTML = '';
      tags.slice(0, START).forEach(function (tag) {
        addTag(tag);
      });
      toggle.removeEventListener('click', onClickShowLoadedTags);
      toggle.addEventListener('click', onClickShowAllTags);
    };

    toggle.addEventListener('click', onClickShowAllTags);
  }
})();

(function () {
  var vpnNewsArrowLeftElement = document.querySelector('.vpn-news__button--left');
  var vpnNewsArrowRightElement = document.querySelector('.vpn-news__button--right');
  var updatesArrowLeftElement = document.querySelector('.updates__button--left');
  var updatesArrowRightElement = document.querySelector('.updates__button--right');

  if (vpnNewsArrowRightElement && updatesArrowRightElement) {
    var activateButton = function (button) {
      button.disabled = false;
    }

    vpnNewsArrowRightElement.addEventListener('click', function () {
      activateButton(vpnNewsArrowLeftElement);
    })

    updatesArrowRightElement.addEventListener('click', function () {
      activateButton(updatesArrowLeftElement);
    })
  }

  $(document).ready(function () {
    $('.slider__container').slick({
      infinite: false,
      initialSlide: 0,
      slidesToShow: 4,
      variableWidth: true,
      slidesToScroll: 3,
      swipeToSlide: true,
      waitForAnimate: false,
      prevArrow: $('.slider__button--right'),
      nextArrow: $('.slider__button--left'),
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 2,
            slidesToScroll:1,
          }
        },
        {
          breakpoint: 525,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
            centerMode: true
          }
        }
      ]
    });
    $('.list__container').each(function () {
      $(this).slick({
        infinite: false,
        initialSlide: 0,
        slidesToShow: 4,
        variableWidth: true,
        slidesToScroll: 3,
        swipeToSlide: true,
        waitForAnimate: false,
        prevArrow: $(this).parent().find('.slider__button--right'),
        nextArrow: $(this).parent().find('.slider__button--left'),
        // arrows: false,
        responsive: [
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 850,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 525,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true
            }
          }
        ]
      });
    })
    $('.vpn-news__slider-container').slick({
      infinite: true,
      swipe: false,
      initialSlide: 0,
      slidesToShow: 3,
      variableWidth: true,
      slidesToScroll: 2,
      prevArrow: $('.vpn-news__button--left'),
      nextArrow: $('.vpn-news__button--right'),
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            swipe: true
          }
        },
        {
          breakpoint: 630,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true
          }
        }
      ]
    });
    $('.updates__slider-container').slick({
      infinite: true,
      swipe: false,
      initialSlide: 0,
      slidesToShow: 4,
      variableWidth: true,
      slidesToScroll: 3,
      prevArrow: $('.updates__button--left'),
      nextArrow: $('.updates__button--right'),
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            swipe: true
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true
          }
        }
      ]
    });
  });
})();

(function () {
  var tabs = document.querySelectorAll('.tabs__js');
  var TAB_CONTENT_CLASS = 'tabs__card';
  var VISIBLE_TAB_CONTENT_CLASS = 'show';
  var TAB_LINK_CLASS = 'tabs__link';
  var MOBILE_LINK_CLASS = 'tabs__link--mobile';
  var ACTIVE_CLASS = 'active';

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tabAriaControls = tab.getAttribute('aria-controls');
      var currentContentBlock = document.querySelector('.' + TAB_CONTENT_CLASS + '.' + VISIBLE_TAB_CONTENT_CLASS);
      var newContentBlock = document.querySelector('#' + tabAriaControls);
      var currentTabLinks = document.querySelectorAll('.' + TAB_LINK_CLASS + '.' + ACTIVE_CLASS);
      var newActiveTabs = document.querySelectorAll('[aria-controls=' + tabAriaControls + ']');

      currentContentBlock.classList.remove(VISIBLE_TAB_CONTENT_CLASS);
      newContentBlock.classList.add(VISIBLE_TAB_CONTENT_CLASS);

      for (var i = 0; i < currentTabLinks.length; i++) {
        currentTabLinks[i].classList.remove(ACTIVE_CLASS);
      }

      for (var i = 0; i < newActiveTabs.length; i++) {
        newActiveTabs[i].classList.add(ACTIVE_CLASS);
      }

      if (tab.classList.contains(MOBILE_LINK_CLASS)) {
        tab.scrollIntoView();
        setTimeout(function () {
          window.scrollBy(0, -50);
        }, 500);
      }
    })
  });
})();